var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Exploration',{attrs:{"categoriesURL":_vm.apiURLs.EXPLORE.PROJECTS.CATEGORIES,"baseExploreURL":_vm.apiURLs.EXPLORE.PROJECTS.EXPLORE,"locationsURL":_vm.apiURLs.EXPLORE.PROJECTS.LOCATIONS,"filters":_vm.projectFilters}})
}
var staticRenderFns = []

export { render, staticRenderFns }